'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowRight01Icon, Cancel01Icon, Tick02Icon } from '@hugeicons-pro/core-stroke-rounded'
import { cn } from '@/lib/utils'
import type { SlashCommandResult } from '@/lib/slash-commands'

type SlashCommandResultCardProps = {
  result: Exclude<SlashCommandResult, { kind: 'llm-routed' }>
}

export function SlashCommandResultCard({ result }: SlashCommandResultCardProps) {
  const isSuccess = result.kind === 'success'
  const isError = result.kind === 'error'
  const message = result.kind === 'navigate'
    ? `Navigating to ${result.path}...`
    : result.message

  return (
    <div className="flex justify-start">
      <div className="inline-flex max-w-[85%] items-center gap-2 rounded-xl border border-atrium-border bg-white px-3 py-2 text-sm text-atrium-black shadow-sm">
        <HugeiconsIcon
          icon={isSuccess ? Tick02Icon : isError ? Cancel01Icon : ArrowRight01Icon}
          className={cn(
            'size-4 shrink-0',
            isSuccess && 'text-emerald-600',
            isError && 'text-red-600',
            result.kind === 'navigate' && 'text-accent-600'
          )}
          aria-hidden
        />
        <span className="min-w-0 break-words">{message}</span>
      </div>
    </div>
  )
}
